import { IRequest } from '@r1-frontend/shared/types/IRequest';

interface IGetProgram {
    startTo: string,
    startFrom: string,
    epgIds: string,
    select?: string,
    with?: string,
}

/*
* Программа передач для определенного набора каналов с epgId
* https://master.api-epg.sandbox.d2c.r-one.io/docs/#/v1/ProgramController_getPrograms
*/

export const getProgram = (params: IGetProgram): IRequest => ({
    uri: '/api/v1/programs',
    method: 'GET',
    queryParams: {
        ...params,
    },
});

